// === AQL&NAFS Size Guide — Injected on Product Pages ===
// Add this file to your Shopify theme: assets/size-charts.js
// Then add {{ 'size-charts.js' | asset_url | script_tag }} before </body> in layout/theme.liquid
(function(){
  "use strict";

  // ── Size chart data keyed by product handle ──
  var charts = {
    // Chart 6 → Aalia Coat (S/M/L)
    "aalia-coat": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)","Sleeves (cm)"],
      r: [["S",112,109,47,60],["M",116,110,48,61],["L",120,111,49,62]]
    },
    // Chart 1 → Lani Down Coat (S/M/L)
    "lani-coat": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)","Sleeves (cm)"],
      r: [["S",114,119,45,64],["M",118,120,46,65],["L",122,121,47,66]]
    },
    // Chart 2 → Nahid Jacket (S–XXL)
    "nahid-jacket": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)","Sleeves (cm)"],
      r: [["S",88,60,39,66],["M",92,61,40,67],["L",96,62,41,68],["XL",100,63,42,69],["XXL",104,64,43,70]]
    },
    // Chart 2 → Mitra Coat (S–XXL)
    "mitra-coat": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)","Sleeves (cm)"],
      r: [["S",88,60,39,66],["M",92,61,40,67],["L",96,62,41,68],["XL",100,63,42,69],["XXL",104,64,43,70]]
    },
    // Chart 2 → Zarifa Coat (S–XXL)
    "zarifa-coat": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)","Sleeves (cm)"],
      r: [["S",88,60,39,66],["M",92,61,40,67],["L",96,62,41,68],["XL",100,63,42,69],["XXL",104,64,43,70]]
    },
    // Chart 2 → Saman Coat (S–XXL)
    "black-beauty": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)","Sleeves (cm)"],
      r: [["S",88,60,39,66],["M",92,61,40,67],["L",96,62,41,68],["XL",100,63,42,69],["XXL",104,64,43,70]]
    },
    // Chart 3 → All Vests (S/M/L, no sleeves)
    "schabnam-vest": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)"],
      r: [["S",92,62,38],["M",96,63,39],["L",100,64,40]]
    },
    "mastani-vest": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)"],
      r: [["S",92,62,38],["M",96,63,39],["L",100,64,40]]
    },
    "noori-vest": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)"],
      r: [["S",92,62,38],["M",96,63,39],["L",100,64,40]]
    },
    "mila-vest": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)"],
      r: [["S",92,62,38],["M",96,63,39],["L",100,64,40]]
    },
    "mamuda-vest": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)"],
      r: [["S",92,62,38],["M",96,63,39],["L",100,64,40]]
    },
    "shaima-vest": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)"],
      r: [["S",92,62,38],["M",96,63,39],["L",100,64,40]]
    },
    // Chart 4 → Iman Cropped Jacket (S–XXL)
    "mani-cropped-jacket": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)","Sleeves (cm)"],
      r: [["S",92,43,39,67],["M",96,44,40,68],["L",100,45,41,69],["XL",104,46,42,70],["XXL",108,47,43,71]]
    },
    // Chart 5 → Gina Cropped Jacket (S/M/L)
    "gina-cropped-jacket": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)","Sleeves (cm)"],
      r: [["S",92,54,40,71],["M",96,55,41,72],["L",100,56,42,73]]
    },
    // Chart 7 → Sahara Coat (S–XXL)
    "sahara-jacket": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)","Sleeves (cm)"],
      r: [["S",88,88,38,70],["M",90,89,39,71],["L",92,90,40,72],["XL",100,91,41,73],["XXL",104,92,42,74]]
    },
    // Chart 7 → Mariam Coat (S–XXL)
    "mariam-coat": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)","Sleeves (cm)"],
      r: [["S",88,88,38,70],["M",90,89,39,71],["L",92,90,40,72],["XL",100,91,41,73],["XXL",104,92,42,74]]
    },
    // Chart 7 → Shiva Coat (S–XXL)
    "shiva-coat": {
      h: ["Size","Bust (cm)","Length (cm)","Shoulder (cm)","Sleeves (cm)"],
      r: [["S",88,88,38,70],["M",90,89,39,71],["L",92,90,40,72],["XL",100,91,41,73],["XXL",104,92,42,74]]
    }
  };

  // ── Detect product handle from URL ──
  var match = window.location.pathname.match(/\/products\/([^?#\/]+)/);
  if (!match) return;
  var handle = match[1];
  var chart = charts[handle];
  if (!chart) return;

  // ── Wait for DOM to be ready ──
  function inject() {
    // Find the last accordion (Description) on the product page
    var accordions = document.querySelectorAll(".accordion__disclosure.group");
    if (!accordions.length) return false;
    var lastAccordion = accordions[accordions.length - 1];
    var wrapper = lastAccordion.closest(".product-info__block-item");
    if (!wrapper) return false;

    // Don't inject twice
    if (document.getElementById("aql-size-guide")) return true;

    // Build table header
    var thCells = chart.h.map(function(h, i) {
      var align = i === 0 ? "left" : "center";
      return '<th style="text-align:' + align + ';padding:10px 12px;font-weight:600;text-transform:uppercase;font-size:12px;letter-spacing:1px;color:#1a1a1a;">' + h + '</th>';
    }).join("");

    // Build table rows
    var trRows = chart.r.map(function(row) {
      var cells = row.map(function(val, i) {
        if (i === 0) return '<td style="padding:10px 12px;font-weight:600;">' + val + '</td>';
        return '<td style="text-align:center;padding:10px 12px;">' + val + '</td>';
      }).join("");
      return '<tr style="border-bottom:1px solid #e5e5e5;transition:background 0.2s;" onmouseover="this.style.background=\'#f9f7f5\'" onmouseout="this.style.background=\'transparent\'">' + cells + '</tr>';
    }).join("");

    // Assemble the accordion HTML
    var html = '<div class="product-info__block-item" id="aql-size-guide">'
      + '<accordion-disclosure class="accordion">'
      + '<details class="accordion__disclosure group">'
      + '<summary><span class="accordion__toggle h6">Size Guide</span></summary>'
      + '<div class="accordion__content prose">'
      + '<div style="overflow-x:auto;">'
      + '<table style="width:100%;border-collapse:collapse;font-size:14px;letter-spacing:0.5px;">'
      + '<thead><tr style="border-bottom:2px solid #1a1a1a;">' + thCells + '</tr></thead>'
      + '<tbody>' + trRows + '</tbody>'
      + '</table></div>'
      + '<p style="margin-top:12px;font-size:12px;color:#888;letter-spacing:0.3px;">'
      + 'All measurements are in centimetres and refer to the garment, not the body.</p>'
      + '</div></details></accordion-disclosure></div>';

    wrapper.insertAdjacentHTML("afterend", html);
    return true;
  }

  // Try immediately, then retry with observer if DOM isn't ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      if (!inject()) {
        var observer = new MutationObserver(function(mutations, obs) {
          if (inject()) obs.disconnect();
        });
        observer.observe(document.body, { childList: true, subtree: true });
        setTimeout(function() { observer.disconnect(); }, 10000);
      }
    });
  } else {
    if (!inject()) {
      var observer = new MutationObserver(function(mutations, obs) {
        if (inject()) obs.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function() { observer.disconnect(); }, 10000);
    }
  }
})();